import { render, staticRenderFns } from "./_base-captcha.vue?vue&type=template&id=9884d8ce&"
import script from "./_base-captcha.vue?vue&type=script&lang=js&"
export * from "./_base-captcha.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports